import { c as _c } from "react/compiler-runtime";
import { NFTLite } from "@/components/user/settings/UserSettingsImgSelectMeme";
import { NextGenCollection } from "@/entities/INextgen";
import { Transaction } from "@/entities/ITransaction";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import UserPageStatsActivityWalletTableRow from "./row/UserPageStatsActivityWalletTableRow";
export default function UserPageStatsActivityWalletTable(t0) {
  const $ = _c(13);
  const {
    transactions,
    profile,
    memes,
    memeLab,
    nextgenCollections
  } = t0;
  let t1;
  if ($[0] !== memeLab || $[1] !== memes || $[2] !== nextgenCollections || $[3] !== profile || $[4] !== transactions) {
    let t2;
    if ($[6] !== memeLab || $[7] !== memes || $[8] !== nextgenCollections || $[9] !== profile) {
      t2 = transaction => <UserPageStatsActivityWalletTableRow key={`${transaction.from_address}-${transaction.to_address}-${transaction.transaction}-${transaction.token_id}`} transaction={transaction} profile={profile} memes={memes} memeLab={memeLab} nextgenCollections={nextgenCollections} />;
      $[6] = memeLab;
      $[7] = memes;
      $[8] = nextgenCollections;
      $[9] = profile;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    t1 = transactions.map(t2);
    $[0] = memeLab;
    $[1] = memes;
    $[2] = nextgenCollections;
    $[3] = profile;
    $[4] = transactions;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[11] !== t1) {
    t2 = <div className="tw-px-4 sm:tw-px-6 tw-mt-4 tw-pb-2 tw-inline-block tw-min-w-full tw-align-middle"><table className="tw-min-w-full"><tbody className="tw-divide-y tw-divide-iron-800 tw-divide-solid tw-divide-x-0">{t1}</tbody></table></div>;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}